import React, { Component } from 'react';

class Projectname extends Component {

  constructor(props){
    super(props);
    this.state = {name:'', color : '0'}
    this.init = this.init.bind(this)
  }

  init(props){
    let color = '#000000'
    if(props.color){
      color = props.color
    }
    this.setState({name: props.children + '', color: color})
  }

  componentWillMount(){
    this.init(this.props)
  }

  componentWillReceiveProps(nextProps){
    this.init(nextProps)
  }

  render() {
    const color = Object.assign({}, {color : this.state.color});
    const backgroundColor = Object.assign({}, {'backgroundColor' : this.state.color})

    return (
      <div className = "project-name" style={color}>
         <span className="project-dot" style={backgroundColor}></span>
          {this.state.name.trunc(25)}
      </div>
    );
  }
}

export default Projectname;
